module.exports = __webpack_public_path__ + "static/work17-3f3615a010b9c28ef3ca496b371d5e03.jpg";